"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transform = void 0;
const traverser_1 = require("./traverser");
const transform = (ast) => {
    const newAst = JSON.parse(JSON.stringify(ast));
    const wrapWithExpressionStatement = (node, parent) => {
        const newNode = {
            generaltype: 'Statement',
            type: 'ExpressionStatement',
            expression: node,
        };
        for (let i = 0; i < parent.body.length; i++) {
            if (parent.body[i] === node) {
                ;
                parent.body[i] = newNode;
            }
        }
    };
    const transformerVisitor = {
        BinaryExpression: {
            enter: (node, parent) => {
                if (parent.type === 'Program' || parent.type === 'BlockStatement') {
                    wrapWithExpressionStatement(node, parent);
                }
            },
        },
        UnaryExpression: {
            enter: (node, parent) => {
                if (parent.type === 'Program' || parent.type === 'BlockStatement') {
                    wrapWithExpressionStatement(node, parent);
                }
            },
        },
        AssignmentExpression: {
            enter: (node, parent) => {
                if (parent.type === 'Program' || parent.type === 'BlockStatement') {
                    wrapWithExpressionStatement(node, parent);
                }
            },
        },
        CallExpression: {
            enter: (node, parent) => {
                if (parent.type === 'Program' || parent.type === 'BlockStatement') {
                    wrapWithExpressionStatement(node, parent);
                }
            },
        },
        ArrayExpression: {
            enter: (node, parent) => {
                if (parent.type === 'Program' || parent.type === 'BlockStatement') {
                    wrapWithExpressionStatement(node, parent);
                }
            },
        },
    };
    traverser_1.traverse(newAst, transformerVisitor);
    return newAst;
};
exports.transform = transform;
